import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import pages from "../pages";
import QueryPreservingLink from "../../components/QueryPreservingLink";
import MobileDropdown from "./MobileDropdown";
import { useSelector } from "react-redux";
import MobileProfile from "./MobileProfile";
import useHasWindow from "../../helpers/useHasWindow";
import { trackMenuNewUser } from "../../helpers/analytics";

const Sidebar = ({ recentReportId, location, setDrawer }) => {
  const theme = useTheme();
  const authLoader = useSelector((state) => state.base.authLoader);
  const isLoggedIn = useSelector((state) => Boolean(state.user.userId));
  const hasWindow = useHasWindow();

  return (
    <Stack sx={{ width: "250px" }}>
      {hasWindow && (
        <>
          {authLoader ? (
            <CircularProgress sx={{ mx: "auto", my: "10px" }} />
          ) : (
            <Stack gap={2}>
              {isLoggedIn ? (
                <MobileProfile setDrawer={setDrawer} />
              ) : (
                <Stack sx={{ p: 3, alignSelf: "center" }} gap={1}>
                  <Button
                    size="small"
                    sx={{ fontSize: 14 }}
                    component={QueryPreservingLink}
                    to="/sign_in"
                  >
                    Login
                  </Button>

                  <Button
                    size="small"
                    variant="contained"
                    disableElevation
                    sx={{ fontSize: 14 }}
                    component={QueryPreservingLink}
                    to="/sign_up"
                    onClick={trackMenuNewUser}
                  >
                    Sign up
                  </Button>
                </Stack>
              )}
            </Stack>
          )}
        </>
      )}

      <Divider />

      {pages.map((page, index) => {
        return (
          <Stack key={index}>
            {page.submenu ? (
              <MobileDropdown
                key={index}
                page={page}
                recentReportId={recentReportId}
                location={location}
              />
            ) : (
              <Stack sx={{ p: 1, alignItems: "center" }}>
                {page.url.includes("https") ? (
                  <Box
                    component="a"
                    key={index}
                    href={page.url}
                    sx={{
                      fontWeight: "bold",
                      textDecoration: "none",
                      color: theme.palette.secondary.main,
                      fontSize: "16px",
                    }}
                  >
                    {page.name}
                  </Box>
                ) : (
                  <Typography
                    component={QueryPreservingLink}
                    to={page.url}
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                      textDecoration: "none",
                      color: theme.palette.secondary.main,
                      "&.active": {
                        color: theme.palette.primary.main,
                      },
                    }}
                    activeClassName="active"
                  >
                    {page.name}
                  </Typography>
                )}
              </Stack>
            )}

            <Divider />
          </Stack>
        );
      })}
    </Stack>
  );
};

export default Sidebar;
